import AvailablePolls from './AvailablePolls';

export default AvailablePolls;
